export default __webpack_public_path__ + "static/media/NewApiKeyCtaImage.202183d0.png";